import moment from "moment";

export const FinancialYearOptions = () => {
    const date = new Date()
    const isApril = date.getMonth() >= 3
    const currentYear1 = date.getFullYear();
    const currentYear = currentYear1 + 1;
    const nonFinancialYear = [2022, 2023, 2024]
    const startYear = 2022;
    const numberOfYears = currentYear - 2021
    const dummyyearOptions = [];
    for (let i = 0; i < numberOfYears; i++) {
        dummyyearOptions.push(startYear + i);
    }
    const yearOptions = dummyyearOptions.map((item) => ({
        label: nonFinancialYear.includes(item) ? `${item}` : `${item - 1}-${item}`,
        value: nonFinancialYear.includes(item) ? `${item}` : `${item - 1}-${item}`
    }));

    const finalData = isApril ? yearOptions : yearOptions?.pop()
    // return finalData
    return yearOptions
}

// export const FinancialMonthOptions = (report) => {
//     const currentYear1 = new Date().getFullYear();
//     const isFinancialYear = typeof report?.academic_year === "string" && report?.academic_year.includes("-")
//     const FinancialMonth = ["April", "May", "June", "July", "August", "September", "October", "November", "December", "January", "February", "March"]
//     const d1 = new Date()
//     const currentMonth1 = d1.getMonth() + 1
//     const years = isFinancialYear && report?.academic_year?.split('-');
//     const year1 = isFinancialYear && years?.length && Number(years[0]);
//     const Financialmonths = isFinancialYear ? (((year1 === currentYear1) && (currentMonth1 >= 4)) ? FinancialMonth.slice(0, currentMonth1 - 3) : ((year1 === currentYear1) && (currentMonth1 < 4)) ? FinancialMonth.slice(0, currentMonth1 + 9) : (year1 !== currentYear1) ? FinancialMonth : []) : FinancialMonth.slice(-3)
//     const monthOptions = Financialmonths?.map((item, i) => ({
//         value: isFinancialYear ? (i <= 8 ? i + 4 : i - 8) : i + 1,
//         label: item
//     }))
//     return monthOptions
// }




export const FinancialMonthOptions = (report) => {
    const d1 = new Date();
    const currentYear1 = d1.getFullYear();
    const currentMonth1 = d1.getMonth() + 1; // 1-12

    const isFinancialYear = typeof report?.academic_year === "string" && report?.academic_year.includes("-");
    const FinancialMonths = ["April", "May", "June", "July", "August", "September", "October", "November", "December", "January", "February", "March"];
    
    // Explicit mapping to match your DB (Jan=1, Feb=2, March=3, etc.)
    const monthMap = {
        "January": 1, "February": 2, "March": 3, "April": 4, "May": 5, "June": 6,
        "July": 7, "August": 8, "September": 9, "October": 10, "November": 11, "December": 12
    };

    let filteredMonths = [];

    if (isFinancialYear) {
        const years = report?.academic_year?.split('-');
        const selectedYear = Number(years[0]);

        // If the selected year is the CURRENT year, limit the months shown
        if (selectedYear === currentYear1 || (selectedYear === currentYear1 - 1 && currentMonth1 <= 3)) {
            // Calculate how many months to show from April
            const monthDiff = currentMonth1 >= 4 ? (currentMonth1 - 4 + 1) : (currentMonth1 + 9);
            filteredMonths = FinancialMonths.slice(0, monthDiff);
        } else {
            // Otherwise show all 12 months for past years
            filteredMonths = FinancialMonths;
        }
    } else {
        // Fallback for old 2022/2023 reports
        filteredMonths = FinancialMonths.slice(-3);
    }

    return filteredMonths.map((item) => ({
        value: monthMap[item],
        label: item
    }));
};



export const ApplyFinancialYearOptions = () => {
    const currentYear1 = new Date().getFullYear();

    const yearOptions = [{
        value: `${currentYear1}-${currentYear1 + 1}`,
        label: `${currentYear1}-${currentYear1 + 1}`
    }]
    return yearOptions
}

export const ApplyFinancialMonthOptions = () => {
    const monthNames = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"];
    const date = new Date("2024-01-01")
    const currentMonth = monthNames[date.getMonth()]
    const previousMonth = date.getMonth() === 3 ? '' : date.getMonth() !== 0 ? monthNames[date.getMonth() - 1] : monthNames[11]
    const dummymonthOptions = [currentMonth, previousMonth]
    const monthOptions = [];

    for (let i = 0; i < dummymonthOptions.length; i++) {
        if (dummymonthOptions[i]) {
            monthOptions.push(dummymonthOptions[i]);
        }
    }

    const options = monthOptions.map((item, i) => ({ 
        value: monthNames.indexOf(item) + 1,
        label: item
    }))
    return options
}
export const IsOldReportYr = (apply) => {
    const oldReportYear = ["2022", "2023"]
    const oldReportYear2 = [2022, 2023]
    const isOldyear = oldReportYear.includes(apply?.academic_year) || oldReportYear2.includes(apply?.academic_year)
    return isOldyear
}
export const IsOldReportYrNum = (apply) => {
    const oldReportYear = [2022, 2023]
    const isOldyear = oldReportYear.includes(apply?.academic_year)
    return isOldyear
}
export const IsOldReportYrm = (apply) => {
    const oldReportYear = [2022, 2023]
    const isOldyear = oldReportYear.includes(apply?.academic_year)
    return isOldyear
}
export const IsOldReportYear = (apply) => {
    let isOldyear
    if (typeof (apply?.academic_year) === 'number') {
        const oldReportYear = [2022, 2023]
        isOldyear = (oldReportYear.includes(apply?.academic_year) || (apply?.academic_year === 2024 && apply?.month?.value < 4))
    } else {
        const oldReportYear = ["2022", "2023"]
        isOldyear = (oldReportYear.includes(apply?.academic_year) || (apply?.academic_year === '2024' && apply?.month?.value < 4))
    }
    return isOldyear
}
export const IsOldReportYearNum = (apply) => {
    const oldReportYear = [2022, 2023]
    const isOldyear = (oldReportYear.includes(apply?.academic_year) || (apply?.academic_year === 2024 && apply?.month < 4))
    return isOldyear
}
export const IsOldReportYearNum1 = (apply) => {
    const oldReportYear = [2022, 2023]
    const isOldyear = (oldReportYear.includes(apply?.academic_year) || (apply?.academic_year === 2024 && apply?.month?.value < 4))
    return isOldyear
}
export const IsOldReportYearx = (apply) => {

    const oldReportYear = [2022, 2023]
    const isOldyear = (oldReportYear.includes(apply?.academic_year) || (apply?.academic_year === '2024' && apply?.months[0]?.value < 4))
    return isOldyear
}

export const Restrict = (evt) => {
    ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()
}

export const FinancialYearView = (month, year) => {
    let year1
    // console.log(typeof month,month)
    // console.log(typeof year,year)
    if (month === 0 || (year === 2024 && month <= 3)) {
        year1 = year
    } else if (month <= 3 && month > 0) {
        year1 = (year - 1) + "-" + year
    } else {
        year1 = year + "-" + (year + 1)
    }
    return year1
}
export const FinancialYearViewIndex = (year) => {
    if (year === 2022 || year === 2023) {
        return year
    } else if (year > 2023) {
        const year1 = year + "-" + (year + 1)
        return year1
    }
}

export const MonthView = (month) => {
    const monthNames = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"];
    const Monthname = monthNames[month - 1]
    return Monthname
}

export const FinancialYearFrom2024 = () => {
    const date = new Date()
    const isApril = date.getMonth() >= 3
    const currentYear1 = date.getFullYear();
    const currentYear = currentYear1 + 1;
    const startYear = 2024;
    const numberOfYears = currentYear - 2024
    const dummyyearOptions = [];
    for (let i = 0; i < numberOfYears; i++) {
        dummyyearOptions.push(startYear + i);
    }
    const yearOptions = dummyyearOptions.map((item) => ({
        label: `${item}-${item + 1}`,
        value: `${item}-${item + 1}`
    }));

    const finalData = isApril ? yearOptions : yearOptions?.pop()
    return finalData
}

export const YearView = (year) => {
    return (year + '-' + (year + 1))
}
export const DefaultYearView = (year) => {
    const d = new Date().getMonth() + 1
    let FinancialYear
    if (d <= 3 && d > 0) {
        FinancialYear = year - 1 + "-" + year
    } else {
        FinancialYear = year + "-" + (year + 1)
    }
    return FinancialYear
}

export const calculateSum = (arr, key) => {
    return arr.reduce((prev, cur) => prev + Number(cur[key] || 0), 0)
}

export const LeaveView = (data) => {
    function summarizeLeave(data) {
        const summary = {};
        data?.forEach(item => {
            const leaveType = item.leave;
            const days = parseInt(item.no_of_days, 10);
            if (summary[leaveType]) {
                summary[leaveType] += days;
            } else {
                summary[leaveType] = days;
            }
        });
        return summary;
    }
    const g = summarizeLeave(data)
    const str = Object.entries(g).map(([leave, days]) => (
        [leave + ' ' + '=' + ' ' + days]
    )).join(', ')
    return str
}

export const NumberOfDays = (startDate, endDate) => {
    const a = new Date(startDate)
    const b = new Date(endDate)
    const DifferenceInMilliSeconds = Math.abs(a - b)
    const NoOfDays = DifferenceInMilliSeconds / (1000 * 60 * 60 * 24) || 0;
    return NoOfDays
}

export const MinimumDate = (date, days) => {
    const startDate = new Date(date);
    const minDate = new Date(startDate);
    minDate.setDate(startDate.getDate() - days);
    const x = moment(minDate).format('yyyy-MM-DD')
    return x
}

export const MaximumDate = (date, days) => {
    const startDate = new Date(date);
    const minDate = new Date(startDate);
    minDate.setDate(startDate.getDate() + days);
    const x = moment(minDate).format('yyyy-MM-DD')
    return x
}

export const Profileinfo = ({ first_name, designation, department }) => {
    return (
        <section className="top-content-container">
            <div className="my-4">
                <div className="row">
                    <div className="col-lg-6">
                        <h6 className="headertext">
                            {first_name} - {designation}
                        </h6>
                        <h6 className="subheadertext">{department}</h6>
                    </div>
                </div>
            </div>
        </section>
    )
}